import { useState } from 'react';
import PropTypes from 'prop-types';
import { LoadingButton } from '@mui/lab';
import { IconButton, InputAdornment, Stack } from '@mui/material';
import FormProvider, { RHFTextField } from '@/components/hook-form';
import Iconify from '@/components/iconify';
import LoadingScreen from '@/components/loading-screen';
import PasswordRequirements from '@/components/password-requirements';
import { useCreatePasswordForm } from './useCreatePasswordForm';

export function CreatePasswordForm({ handleClose }) {
  const [showPassword, setShowPassword] = useState(false);
  const {
    methods,
    onSubmit,
    isSubmitting,
    isLoadingCreatePassword,
    password,
    passwordServerErrors,
    passwordHasError,
  } = useCreatePasswordForm({ handleClose });

  return (
    <FormProvider methods={methods} onSubmit={onSubmit}>
      <Stack spacing={3}>
        <RHFTextField
          name="password"
          label="Senha"
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  data-testid="password-button"
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                >
                  <Iconify
                    data-testid="password-icon"
                    icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'}
                  />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <PasswordRequirements
          value={password}
          serverErrors={passwordServerErrors}
          showErrors={passwordHasError}
        />

        <RHFTextField
          name="confirmPassword"
          label="Confirme a sua senha"
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  data-testid="confirm-password-button"
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                >
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={isSubmitting}
          sx={{ mt: 3 }}
        >
          Criar senha
        </LoadingButton>
      </Stack>

      {isLoadingCreatePassword && <LoadingScreen />}
    </FormProvider>
  );
}

CreatePasswordForm.propTypes = {
  handleClose: PropTypes.func.isRequired,
};
